import { AxiosResponse } from "axios";

export class DataResponse {
  code = -1;
  data = null;
  message = null;
  status = 0;
  success = false;
  time = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  bind(res: any) {
    this.code = res.code;
    this.data = res.data;
    this.message = res.message;
    this.status = res.status;
    this.success = res.success;
    this.time = res.time;
  }
  isSuccess() {
    return this.success;
  }
}

export class PageResponse {
  pageNumber = 0;
  size = 10;
  totalPages = 0;
  totalElements = 0;

  bind(res: any) {
    this.pageNumber = res.pageNumber;
    this.size = res.size;
    this.totalPages = res.totalPages;
    this.totalElements = res.totalElements;

    return this;
  }
}
